export enum PayloadType {
    Transaction = 'transaction',
    Transactions = 'transactions',
    Block = 'block',
    Blocks = 'blocks'
}
